// ACRYLMALL カート行の現在時刻 properties[_時間]
//
// 商品ページの product-form の中に
//   <input type="hidden" id="currentTime" name="properties[_時間]">
// を置いて、購入時の現在時刻を「dd/mm/yyyy HH:MM:SS」で line item に
// 添付する。Channel.io / 帳票連携で「いつ注文した line か」を見るのに使う。

document.addEventListener('DOMContentLoaded', function () {
  const input = document.getElementById('currentTime');
  if (!input) return;

  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  input.value = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
});
